import { render, staticRenderFns } from "./FormBannerPhotoComponent.vue?vue&type=template&id=6ddf102e&scoped=true"
import script from "./FormBannerPhotoComponent.vue?vue&type=script&lang=js"
export * from "./FormBannerPhotoComponent.vue?vue&type=script&lang=js"
import style0 from "./FormBannerPhotoComponent.vue?vue&type=style&index=0&id=6ddf102e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ddf102e",
  null
  
)

export default component.exports